import { render, staticRenderFns } from "./_MealBlock.vue?vue&type=template&id=444c7d5f"
import script from "./_MealBlock.vue?vue&type=script&lang=js"
export * from "./_MealBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports